import { HelpThickIcon } from "@minervaproject/fds";
import { useCallback } from "react";
import { useIntercom } from "react-use-intercom";

import { Menu } from "./menu";
import { MenuItem } from "./menu_item";

import { forumClassUrl } from "api/api_client";
import { INTERCOM_ENABLED, MINERVA_RESOURCES_ENVIRONMENT } from "config";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { PROFILE_PROPERTIES, useUserProperties } from "hooks/use_user_properties";
import { LocalModalContentType } from "shared/types";
import { classroomSelectors } from "store";
import { showLocalModal } from "store/reducers/local";
import { shortDisplayName } from "utils/user";

function HelpMenu({ userId }: { userId: string }) {
  const dispatch = useAppDispatch();
  const { show, update } = useIntercom();
  const user = useUserProperties(userId, PROFILE_PROPERTIES.concat("bandwidth_mode", "role"));
  const classId = useAppSelector(classroomSelectors.selectClassId());
  const orgName = useAppSelector(classroomSelectors.selectOrgName());
  const helpTopicsUrl = "https://help.minervaproject.com/en/";
  const systemCheckUrl = `${forumClassUrl}/system-check`;
  const featureRequestUrl = "https://form.asana.com/?k=4H0EalddMqOUf5PCqAExRw&d=914015496185";

  const handleReportBug = () => {
    dispatch(showLocalModal({ content: LocalModalContentType.BugReportForm }));
  };

  const openIntercom = useCallback(() => {
    if (!user) return;
    update({
      userId: `${MINERVA_RESOURCES_ENVIRONMENT}-${user.id}`,
      userHash: user.intercom_hash,
      name: `${shortDisplayName(user)} - ${MINERVA_RESOURCES_ENVIRONMENT}`,
      email: user.email,
      customAttributes: {
        class_id: classId,
        org: orgName,
        role: user.role,
        bandwidth: user.bandwidth_mode,
        monitoring_dashboard: `${window.location.hostname}/monitoring/classes/${classId}`,
      },
      hideDefaultLauncher: true,
    });
    show();
  }, [classId, orgName, user, show, update]);

  const handleKeyboardShortcuts = () => {
    dispatch(showLocalModal({ content: LocalModalContentType.KeyboardShortcuts }));
  };

  return (
    <Menu tooltip="Help" IconComponent={HelpThickIcon} ariaLabel="Help Menu">
      <MenuItem text="Help Topics" href={helpTopicsUrl} target="_blank" />
      <MenuItem text="Report a Bug" onClick={handleReportBug} />
      {INTERCOM_ENABLED && <MenuItem text="Live Tech Support" onClick={openIntercom} />}
      <MenuItem text="System Check" href={systemCheckUrl} />
      <MenuItem text="Keyboard Shortcuts" onClick={handleKeyboardShortcuts} />
      <MenuItem text="Suggest a Feature" href={featureRequestUrl} target="_blank" />
    </Menu>
  );
}

export { HelpMenu };
